<template>
  <div>
    <v-footer class="justify-center" :color="getThemeColor" dark height="40" absolute>
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >&copy; {{ (new Date()).getFullYear() }} — {{getAppName}} | Made with 💜 by Baron IT Solutions [076 243 9441]</div>
    </v-footer>
  </div>
</template>

<script>
export default {
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    }
  }
};
</script>

<style>
</style>